"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMemoArrayMap;

var _react = require("react");

function useMemoArrayMap(array, mapper) {
  var prevMapperRef = (0, _react.useRef)();
  var sameMapper = Object.is(mapper, prevMapperRef.current);
  var prevMapperCallsRef = (0, _react.useRef)([]);

  var _ref = sameMapper ? prevMapperCallsRef : {},
      _ref$current = _ref.current,
      prevMapperCalls = _ref$current === void 0 ? [] : _ref$current;

  var nextMapperCalls = [];
  return (0, _react.useMemo)(function () {
    var mapped = array.map(function (value, index) {
      var prevResult = prevMapperCalls.find(function (_ref2) {
        var targetValue = _ref2.value;
        return targetValue === value;
      });

      var _ref3 = prevResult || {},
          _ref3$result = _ref3.result,
          result = _ref3$result === void 0 ? mapper.call(array, value, index) : _ref3$result;

      nextMapperCalls.push({
        result: result,
        value: value
      });
      return result;
    });
    prevMapperCallsRef.current = nextMapperCalls;
    prevMapperRef.current = mapper;
    return mapped;
  }, [array, mapper]);
}